import React from 'react'

import { UsageCardsWidget } from '@/views/Analytics/widgets/UsageCardsWidget'
import Widget from '@/components/widget/Widget'

import { CountByDateWidget } from '../widgets/CountByDateWidget'
import { UsersWithAllCallsWidget } from '../widgets/UsersWithNoCallsWidget'
import { CallsByUserWidget } from '../widgets/CallsByUserWidget'

export const UsageSection = () => {
  return (
    <div data-testid="reports-usage">
      <UsageCardsWidget />
      <Widget
        widgetId="usage-usersWithNoCalls"
        label="Usage Report"
        subtitle="All users and their call activity in the selected date range"
        tableOnly
        showCsvDownload
      >
        <UsersWithAllCallsWidget />
      </Widget>
      <Widget
        widgetId="usage-usersWithCalls"
        label="Users With Calls"
        subtitle="Time series of the count of agents with calls"
        showViewToggle
        showCsvDownload
      >
        <CountByDateWidget countedObj="user" />
      </Widget>
      <Widget
        widgetId="usage-totalCalls"
        label="Total Calls"
        subtitle="Count of calls by users in the time period"
        showGroupBy
        showViewToggle
        showCsvDownload
      >
        <CountByDateWidget countedObj="call" />
      </Widget>
      <Widget
        widgetId="usage-callsByUser"
        label="Calls By User"
        subtitle="The count of calls for each select agent"
        showViewToggle
        showCsvDownload
      >
        <CallsByUserWidget />
      </Widget>
    </div>
  )
}
